import { NextPage } from 'next'
import { Box, Typography, Grid } from '@mui/material'
import { isDesktop } from 'react-device-detect'

export const Privacy: NextPage = () => {

    const data = [
        {
            'type': 1,
            'content': 'Personal Data and Privacy Policy (“Privacy Policy”)',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'INTRODUCTION',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'Shenma Credit Sdn. Bhd. (Company No.: 201401009329 / 1085407-K) and its affiliates and related companies (individually and collectively, “Shenma”, “we”, “us” or “our”) takes its responsibilities under applicable privacy laws and regulations, including but not limited to the Personal Data Protection Act 2010 (Laws of Malaysia, Act 709)(“Privacy Laws”) seriously and is committed to respecting the privacy rights and concerns of all users of our website and app (the “Sites”). We recognize the importance of the personal data you have entrusted to us and believe that it is our responsibility to properly manage, protect and process the personal data you have entrusted to us. This Privacy and Data Protection Policy (“Privacy Policy” or “Policy”) is designed to assist you in understanding how we collect, use, disclose and/or process the personal data you have provided to us and/or possess about you, whether now or in the future, as well as to assist you in making an informed decision before providing us with any personal data. Please read this Privacy Policy carefully. If you have any questions regarding this information or our privacy practices, please see the section entitled “Questions, Concerns or Complaints? Contact Us” at the end of this Privacy Policy.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'By using the Sites, registering for an account with us, or accessing the Services, you acknowledge and agree that you accept the practices, requirements, and/or policies outlined in this Privacy Policy, and you hereby consent to us, and undertake to procure the consent of your users to us, collecting, using, disclosing and/or processing your personal data and the personal data of your users as described herein. IF YOU DO NOT CONSENT AND/OR DO NOT PROCURE THE CONSENT OF YOUR USERS TO THE COLLECTING, USING, DISCLOSING AND/OR PROCESSING OF YOUR PERSONAL DATA AND THE PERSONAL DATA OF YOUR USERS AS DESCRIBED IN THIS PRIVACY POLICY, PLEASE DO NOT USE OUR SERVICES OR ACCESS OUR WEBSITE.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We may from time to time update this Privacy Policy to reflect our current practice and ensure compliance with data protection laws. We reserve the right to amend this Privacy Policy at any time.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'What Information We Collect About You',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': '(a) Information you provide us directly',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We ask for information about you directly from you when you apply motorcycle financing with us. This includes but is not limited to, your name; address; contact details; passport or driver\'s licenses; financial and related information such as bank statements, identity card, bank account details, salary information, employment details and utility bills. This may also include your biometric information including a photo of your face. We request this information to verify your identity, to assess your application with us, and should your application be approved, to manage any motorcycle financing provided to you.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We may also collect information about you if you are a person who proposes to guarantee or has guaranteed repayment of any application for motorcycle financing made with us.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We may also collect information about you when you contact us directly by telephone, via our website, email or a social media platform managed by us',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) Information we receive from third parties',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We may obtain information about you from third parties to verify your identity before processing any application for motorcycle financing with us.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'When you apply for motorcycle financing with us, we may obtain credit-related information about you from third parties for the purposes of assessing and processing your application for motorcycle financing. Credit-related information is a type of personal information that includes information about your credit history or creditworthiness. This includes information, but is not limited to, about your loan experience with us and other lenders; the kinds of credit products you have had or sought; how you have managed your credit obligations such as your repayment history and arrears; and a credit report which we obtain from a credit reporting body which contains information about your creditworthiness. We also obtain credit information as we are required to ascertain and verify a prospective borrower’s financial situation.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'How We Use Your Information',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'We collect the information about you for purposes set out above and which is described in more detail below:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) Assessing application: We primarily use your personal information to assess your application for motorcycle financing including obtaining a motorcycle financing report; and assess, process, provide and administer your application for motorcycle financing.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) Providing you with our services: If your application is accepted by us, we will primarily use your information to provide you with our services – that is the provision and management of any motorcycle financing facility offered and accepted by you.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) For data analytics: We use information about you to improve our services and your experience with our Sites such as monitoring the total number of visitors, traffic and site usage patterns.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(d) To communicate with you: We use personal information provided to communicate with you including in response to any request from you, to gain feedback about your experience with us, for marketing and promotional purposes. This includes contacting you by telephone or in writing, and by sending commercial electronic messages to any electronic address which you provide or for which you are responsible. You consent and agree (either as or on behalf of the electronic account holder) that we may continue to send commercial electronic messages to those addresses.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(e) Where required by law: We may use or disclose your information where we are required to by law or in order to comply with the law including reasonable requests from law enforcement.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Sharing Your Information with Third Parties',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'We may disclose your information to third parties, where necessary.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Such third parties include, but are not limited to:',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) Our subsidiaries, affiliates and related corporations;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) Your referee or employers to verify the information that you have provided;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) Our external service providers including agents, business partners, lawyers, debt collection agencies, lawyers and entities that assist us to verify your identity or illegal activities and prevent fraud;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(d) Credit reporting bodies/agencies;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(e) Any law enforcement, government, courts, dispute resolution bodies and regulatory bodies;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We may obtain a credit report about you from Credit Reporting Agency (CRA) and in order to do so, we may share your personal data to CRA.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'A credit report will provide us with information about you that is held by the CRB and which has any bearing on your credit worthiness in your capacity as a borrower.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We may use this information to confirm your identity, assess an application for motorcycle financing, manage our relationship with you and collect overdue payments.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'How Do We Keep Your Personal Information Safe',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'Although data transmission over the Internet or website cannot be guaranteed to be totally secure, we work hard to maintain physical, electronic and procedural safeguards to protect your information in accordance with applicable data protection requirements. We regularly review and implement up-to-date technical and organisational security measures when processing your personal information.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Our employees are trained to handle the personal information securely and with utmost respect, failing which they may be subject to disciplinary action.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Do not forget your responsibility for maintaining the secrecy of your unique password and account information.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'How Long We Retain Your Information',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'We will only retain your information for as long as necessary to fulfil the purpose(s) for which it was collected or to comply with legal, regulatory and internal requirements. Afterwards we will destruct or permanently delete your information.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Your Options About Your Information',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': '(a) Account information',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You may update your account information either through your account online or by contacting our Customer Service Unit at 045230033.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You may not opt out of certain account-related communications (such as payment reminders, changes/updates to your account, technical and security notices etc).',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) Direct Marketing',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We may use your information to advertise or promote services, or business opportunities we think may interest you, including by email, telephone or message. We may also provide your information to other organisations for specific marketing purposes.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) Access, Amend and Correct Your Information',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'We take all reasonable steps to ensure that the information we may collect, use or disclose is accurate, complete and up-to-date. You have rights to access your information and correct it if it is inaccurate, out-of-date or incomplete.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You may request access to the information we hold about you at any time by contacting us. We will respond to your request within a reasonable time. There is no fee for making a request, but we may charge you the reasonable costs of providing our response to a request for access to personal information.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If we refuse to give you access to any of your personal information, we will provide you with reasons for the refusal and the relevant provisions of the Privacy Laws on which we rely to refuse access.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You may also ask us to correct any information we hold about you by contacting us. We encourage you to advise us as soon as there is a change to your contact details, such as your phone number or address. We will deal with your request to correct your information in a reasonable time. If we correct your information and it is information we have provided to others, we will notify them of the correction where we are required to do so by the Privacy Laws. We will correct information as soon as possible upon your request.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If we do not agree with the corrections you have requested, we are not obliged to amend your information accordingly.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Cookies',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'When you visit the Sites, we use cookies to identify user behaviours, continually enhance your browsing experience and improve our Site. “Cookies” are identifiers transferred to your computer or mobile device that allow us to recognize your device and gather information about how and when the Services or Site are used, the number of users, and to track movements within the Site. Cookies may convey information about your device, including, but not limited to, your IP address, operating system, browser name/version, the referring web page, and requested page, along with the date/time of your visit. You have the option to enable or disable all cookies directly through your web browser, allowing you to customize your cookies preferences. However, certain Site features may not operate optimally if cookies are disabled.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Our Site uses Google Analytics, a web analytics service provided by Google, Inc. (“Google”). Google Analytics uses cookies, which are text files placed on your computer, to help analyse how users use the Site.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Google will use this information to evaluate your use of the Site, compile reports on website activity for website operators and provide other services relating to Site activity and Internet usage. Google may also transfer this information to third parties where required by law, or where such third parties process the information on Google’s behalf. Google will not associate your IP address with any other data held by Google. You may learn about Google’s practices by referring to Google’s Privacy Policy.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': 'Questions, Concerns or Complaints? Contact Us',
            'paddingLeft': '0px',
            'underline': true
        },
        {
            'type': 2,
            'content': 'If you have any questions or concerns about our privacy practices or your dealings with the Services, please do not hesitate to contact Consumer Service Unit through email or call us at the following email address and contact number:-',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Contact Number: +604 523 0033',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Email: wecare@shenmacredit.com.my',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If you have any questions, concerns or feedbacks regarding how we are handling your Personal Data and/or the Personal Data or about how we are complying with Privacy Laws, we welcome you to contact us with your questions, concerns or feedbacks',
            'paddingLeft': '0px',
            'underline': false
        }
    ]

    const titleItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12}>
                <Typography fontSize={isDesktop ? 22 : 16} fontWeight={600} color={'#333333'} style={{ textDecoration: underline ? 'underline' : 'none' }}>{content}</Typography>
            </Grid>
        )
    }

    const contentItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12} style={{ textDecoration: underline ? 'underline' : 'none' }}>
                <Typography fontSize={isDesktop ? 18 : 14} color={'#333333'} paddingLeft={paddingLeft}>{content}</Typography>
            </Grid>
        )
    }

    return (
        <Box sx={{
            width: '100%',
            paddingTop: isDesktop ? '60px' : '30px',
            paddingBottom: '60px',
            paddingLeft: isDesktop ? '100px' : '20px',
            paddingRight: isDesktop ? '100px' : '20px',
        }}>
            <Grid container rowSpacing={2}>
                {data.map((item, index) => (
                    data[index]['type'] === 1 ? titleItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline']) : contentItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline'])
                ))}
            </Grid>
        </Box>
    )
}
